import UsFlag from '../../assets/images/auth/flags/us.svg'
import CaFlag from '../../assets/images/auth/flags/ca.svg'
import { RESIDENCIES, type Residency } from '../../models/Residency'

interface ResidencyOption {
  value: Residency
  label: string
  flag: string
}

const RESIDENCY_DISPLAY: Record<Residency, { label: string; flag: string }> = {
  us: { label: 'United States', flag: UsFlag },
  ca: { label: 'Canada', flag: CaFlag },
}

export const RESIDENCY_OPTIONS: ResidencyOption[] = RESIDENCIES.map((value) => ({ value, ...RESIDENCY_DISPLAY[value] }))

export const residencyLabel = (residency: Residency): string => RESIDENCY_DISPLAY[residency].label

export const DATA_REGION_CONTENTS = [
  'AI Assistant summaries and results',
  'Client profiles and records',
  'Meeting transcripts',
  'Meeting details',
  'Audit logs',
]
